import { useEffect, useState } from 'react';
import { ObsEncoderInfo } from '../../types/obs';
import { SelectSimple } from '../Select';
import { getAvailableEncoders } from '../../constants/encoders';

export function ObsEncoderClassSelector({type, value, label, disabled = false, onChange} : {
    type: 'audio' | 'video',
    value: string | undefined,
    label: string,
    disabled?: boolean,
    onChange?: (value: string) => void,
}) {
    const [availableEncoders, setAvailableEncoders] = useState<ObsEncoderInfo[]>([]);

    function currentValue(): string {
      if (value) {
        return value;
      }

      if (availableEncoders.length) {
        return availableEncoders[0].class;
      }

      return '';
    }

    useEffect(() => {
      const abortController = new AbortController();

      getAvailableEncoders(type).then((encoders) => {
        if (abortController.signal.aborted) {
          return;
        }

        setAvailableEncoders(encoders.filter((item) => {
          return item.class === value || !item.isDeprecated;
        }));

        if (currentValue() !== value) {
          onChange?.(currentValue());
        }
      });

      return () => {
        abortController.abort();
      };
    });

    return (<>
      <SelectSimple
        disabled={disabled}
        label={label}
        options={new Map(availableEncoders.map((item) => { return [String(item.class), item.label]; }))}
        disabledOptions={new Set(availableEncoders.filter((item) => item.isDeprecated).map((item) => item.class))}
        value={currentValue()}
        onChange={onChange}
      />
    </>);
}
